export const PERMISSIONS_TABLE = 'permissions'
export const PERMISSION_ROLE_TABLE = 'permission_role'
export const DEVICE_TABLE = 'devices'
export const HOSPITAL_DEVICE_TABLE = 'hospital_device'
export const HOSPITAL_INFO_TABLE = 'hospital_info'
export const USER_INFO_TABLE = 'user_info'
export const HOSPITALS_TABLE = 'hospitals'
export const PATIENT_TABLE = 'patient'
export const INDIVIDUAL_DEVICE_TABLE = 'individual_device'
export const NURSE_DEVICE_TABLE = 'nurse_device'
export const DEVICE_CONTROL_TABLE = 'device_control'
export const PATIENT_DEVICE_TABLE = 'patient_device'
export const PATIENT_HOSPITAL_BLOCK_TABLE = 'patient_hospital_block'
export const DEVICE_LIVE_DATA_TABLE = 'deviceLiveData'
export const DEVICE_CHANGE_LOG_TABLE = 'deviceChangeLog'
export const HOSPITAL_BLOCK_TABLE = 'hospital_block'
export const AUDIT_LOG_TABLE = 'audit_log'